export const isMobile = document.documentElement.clientWidth < 600
